<div  [ngClass]="theme" [class.border-radius]="rounded">
    <div class="wrapper">
        <div class="wrapper-icon">
            <mat-icon class="icon">{{icon}}</mat-icon>
        </div>
        <div class="text">
            <span>{{text}}</span>
        </div>
        <div class="reject" *ngIf="isCloseable">
            <button mat-icon-button aria-label="cerrar actionable-button" (click)="onRejectClick()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <button mat-button class="link" *ngIf="linkText" (click)="onLinkClick()">
        {{linkText}}
    </button>
</div>

  